import { getPagePath, PREVIOUS_PAGE } from "../helpers/pageLinkSelectors";

export const getPreviousPagePath = state =>
  getPagePath({ state, direction: PREVIOUS_PAGE });
